var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "56px",
    viewBox: "0 0 64 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning_icon_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-173.000000, -27.000000)",
    stroke: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_icon_grey",
    transform: "translate(173.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(29.000000, 18.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.5,
    y: 0.5,
    width: 3,
    height: 20,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 2,
    cx: 3,
    cy: 27,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.4188966,4.35709836 L2.68294873,49.4894065 C1.83849376,50.9149105 2.30952711,52.7550759 3.73503116,53.5995309 C4.19792206,53.873743 4.72603701,54.0184274 5.26405215,54.0184274 L58.7359479,54.0184274 C60.3928021,54.0184274 61.7359479,52.6752817 61.7359479,51.0184274 C61.7359479,50.4804123 61.5912634,49.9522974 61.3170513,49.4894065 L34.5811034,4.35709836 C33.7366484,2.9315943 31.8964831,2.46056096 30.470979,3.30501593 C30.0375044,3.56180213 29.6756828,3.92362377 29.4188966,4.35709836 Z",
    id: "Path-3",
    strokeWidth: 3.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconGrey);
export default __webpack_public_path__ + "static/media/warning_icon_grey.0008d1513f75be80f0d361b98257629b.svg";
export { ForwardRef as ReactComponent };